import air from './air'
import approvals, { FILTER_PERSISTOR as FILTER_APPROVALS } from './approvals'
import audits, { FILTER_PERSISTOR as FILTER_AUDITS } from './audits'
import auth, { FILTER_PERSISTOR as FILTER_AUTH } from './auth'
import cities from './cities'
import closings, { FILTER_PERSISTOR as FILTER_CLOSINGS } from './closings'
import conferences, {
  FILTER_PERSISTOR as FILTER_CONFERENCES
} from './conferences'
import groupTrees from './groupTrees'
import hotels from './hotels'
import issuances from './issuances'
import partners from './partners'
import partner_hotel_rooms from './partners/bedrooms'
import agency_partners from './partners/link-agency'
import agency_partner_hotel_offers from './partners/offer'
import partner_hotels from './partners/hotels'
import agreement from './partners/agreement'
import agency_partner_hotel_agreements from './partners/agreementsOffer'
import me, { FILTER_PERSISTOR as FILTER_ME } from './me'
import organizations from './organizations'
import requests, { FILTER_PERSISTOR as FILTER_REQUESTS } from './requests'
import resources, { FILTER_PERSISTOR as FILTER_RESOURCES } from './resources'
import tree from './tree'
import users, { FILTER_PERSISTOR as FILTER_USERS } from './users'
import vehicles from './vehicles'

export default {
  air,
  approvals,
  audits,
  auth,
  cities,
  closings,
  conferences,
  groupTrees,
  hotels,
  issuances,
  agreement,
  agency_partner_hotel_agreements,
  partners,
  partner_hotel_rooms,
  agency_partner_hotel_offers,
  partner_hotels,
  agency_partners,
  me,
  organizations,
  requests,
  resources,
  tree,
  users,
  vehicles
}

export const WHITE_LIST: string[] = [
  'approvals',
  'audits',
  'auth',
  'closings',
  'conferences',
  'me',
  'requests',
  'resources',
  'users'
]

export const BLACK_LIST: string[] = []

export const FILTERS_PERSISTOR = [
  FILTER_APPROVALS,
  FILTER_AUDITS,
  FILTER_AUTH,
  FILTER_CLOSINGS,
  FILTER_CONFERENCES,
  FILTER_ME,
  FILTER_REQUESTS,
  FILTER_RESOURCES,
  FILTER_USERS
]
